import { EventEmitter, Injector, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import dayjs from 'dayjs';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { EventsInfo } from 'src/app/Models/MisEventos/eventsInfo';
import { TravelEvents } from 'src/app/Models/MisEventos/travelEvents';
import { Coordinate } from 'src/app/Models/MisViajes/Coordinate';
import { Seguro } from 'src/app/Models/seguro';
import { ApiService } from 'src/app/Services/api.services';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import moment from 'moment';

@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.css']
})
export class EventosComponent implements OnInit {

  isReady: boolean;
  eventsInfo: EventsInfo;
  loader: boolean;
  loaderMap: boolean;
  fechaInicio: Date;
  fechaFin: Date;
  travelEventsMap: TravelEvents;
  asegurado: Asegurado;
  seguro: Seguro;
  daterange: any = {};
  datelabel: string = '';

  @Output() selectedDate:EventEmitter<any> = new EventEmitter(false);

  public options: any = {
    locale: {
      format: "DD/MM/YYYY",
      opens: 'center',
      separator: " - ",
      applyLabel: "Aplicar",
      cancelLabel: "Cancelar",
      fromLabel: "Desde",
      toLabel: "Hasta",
      customRangeLabel: "Rango Personalizado",
      weekLabel: "W",
      daysOfWeek: [
          "Do",
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa"
      ],
      monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Augosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
      ],
      firstDay: 1
  },
    alwaysShowCalendars: false,
    ranges: {
      'Hoy': [moment(), moment()],
      'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
      'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
      'Este mes': [moment().startOf('month'), moment().endOf('month')],
      'Mes Pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    },
    startDate: moment().subtract(6, 'days'),
    endDate: moment(),
    minDate: moment().subtract(29, 'days'),
    maxDate: moment()
  };



  constructor(private apiService: ApiService, private inj: Injector, private router: Router) {
    this.isReady = true;
  }
  daterangepickerOptions = {

  };
  ngOnInit(): void {

    this.eventsInfo = new EventsInfo();
    this.loader = true;
    this.loaderMap = true;
    let todayDate = new Date();
    let startDate = moment().subtract(6, 'days').toDate();
    let endDate = moment().toDate();
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));

    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos de MisEventos: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${todayDate.toString()})`);

    this.obtainDataMyEvents(startDate, endDate);
  }



  rangeSelected(evt): void{
    this.loader = true;
    this.fechaInicio = new Date(evt.start.format('MM/DD/YYYY'));
    this.fechaFin = new Date(evt.end.format('MM/DD/YYYY'));
    this.obtainDataMyEvents(this.fechaInicio, this.fechaFin);
  }

  obtainDataMyEvents(initDate: Date, endDate: Date): void{
    if (isNaN(initDate.getTime())) {
      initDate = new Date();
      endDate = new Date();
    }

    this.apiService.ObtainDataMyEvents(localStorage.getItem('firstIdVoucher'), initDate, endDate).subscribe((response: any) => {
      //console.log('response:' + JSON.stringify(response));
      this.eventsInfo = response;
      this.loader = false;

      if (this.eventsInfo.events.length > 0) {
        this.travelEventsMap = this.eventsInfo.events[0];
        this.loaderMap = false;
      }
      else{
        this.loaderMap = true;
      }
    },
    error => {
      const appInsightService = this.inj.get(AppInsightsService);
      appInsightService.logException(error);
      this.handleOfferErrorTechniques(error);
    });
  }

  changeMarkerMap(travelEvents: TravelEvents): void{
    this.travelEventsMap = travelEvents;
    let elmnt = document.getElementById('mapa');
    elmnt.scrollIntoView({behavior: 'smooth'});
    this.loaderMap = false;
  }

  public handleOfferErrorTechniques(error: any): void {
    this.router.navigate(['/errortechniques']);
  }

  public dateSelected(message: any) {
    //console.log('registro:' + JSON.stringify(message));
    this.selectedDate.emit(message);
    this.loader = true;
    this.fechaInicio = new Date(message.start.format('MM/DD/YYYY'));
    this.fechaFin = new Date(message.end.format('MM/DD/YYYY'));
    this.obtainDataMyEvents(this.fechaInicio, this.fechaFin);
  }

}
